<template>
  <div :class="[surfaceClass, { 'p-3': !noSpace }]">
    <slot></slot>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  dark: Boolean,
  color: {
    type: String,
    value: 'bg-white',
  },
  variant: {
    type: String,
    default: 'default',
  },
  noSpace: Boolean,
})

const surfaceClass = computed(() => {
  if (props.variant === 'cockpit') {
    return 'rounded-lg border border-cockpit-line bg-cockpit-surface text-cockpit-text shadow-cockpit'
  }

  return 'rounded-lg border border-gray-200 bg-white'
})
</script>
